import React from "react";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";

const gradientSx = {
  p: 2,
  borderRadius: 1,
  background: (theme) =>
    theme.palette.mode === "light"
      ? "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%)"
      : theme.palette.background.paper,
  border: "1px solid rgba(37, 99, 235, 0.2)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
};

/**
 * Gradient border Paper used across PG Home dashboard panels.
 */
export default function PgHomeSectionPaper({ children, sx, ...paperProps }) {
  return (
    <Paper elevation={0} sx={{ ...gradientSx, ...sx }} {...paperProps}>
      {children}
    </Paper>
  );
}

PgHomeSectionPaper.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
